import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminAuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get("/admin/audit-logs?limit=200").then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, []);
  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Audit trail</div>
        <h1 className="headline-xl">Audit logs</h1>
      </header>
      <div data-testid={ADMIN.auditList} className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">Actor</th>
              <th className="px-4 py-3">Target</th>
              <th className="px-4 py-3">Meta</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} data-testid={ADMIN.auditRow(l.id)} className="border-b border-white/5">
                <td className="px-4 py-3 text-xs text-lifted-dim whitespace-nowrap">{l.at}</td>
                <td className="px-4 py-3"><code className="text-lifted-green text-xs">{l.action}</code></td>
                <td className="px-4 py-3 text-xs text-lifted-dim break-all">{l.actor_id || "—"}</td>
                <td className="px-4 py-3 text-xs text-lifted-dim break-all">{l.target_id || "—"}</td>
                <td className="px-4 py-3 text-xs text-lifted-mute"><pre className="whitespace-pre-wrap break-all max-w-xs">{JSON.stringify(l.meta || {})}</pre></td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-10 text-center text-lifted-dim">No events yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
